const dev = require('./config.dev.json');
const prod = require('./config.prod.json');
const staging = require('./config.staging.json');

export default (process.env.NODE_ENV === 'production') ? prod : (process.env.NODE_ENV === 'staging') ? staging : dev;